<template>
    <div>
        <!-- Modal -->
        <div class="modal fade" :id="modal_name" data-backdrop="static" data-keyboard="false" tabindex="-1" role="dialog" aria-labelledby="modelTitleId" aria-hidden="true">
            <div class="modal-dialog modal-lg modal-dialog-scrollable modal-dialog-total" role="document">
                <div class="modal-content modal-content-total">
                    <div class="modal-header" v-if="false">
                        <h5 class="modal-title">Reconhecer Pedido</h5>
                        <button type="button" class="close" @click="fechar()" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <az-loading v-if="!dados" msg="Aguarde..." />

                        <template v-else>
                            <div>
                                <div class="progress">
                                    <div class="progress-bar" :class="progresso == 100 ? 'bg-success' : ''" role="progressbar" :style="'width: ' + progresso + '%'"></div>
                                </div>
                            </div>

                            <div class="form-row">
                                <div class="col col-12 col-md-6">
                                    <div class="card overflow-auto bg-light card-fixo mb-0" v-if="dados && dados.ocr && dados.ocr.dicionario">
                                        <table class="table table-sm">
                                            <tr :key="iix" v-for="(exame, iix) in dados.ocr.dicionario">
                                                <td width="50%">
                                                    <span v-if="exame.partes" class="text-muted">
                                                        <i class="fa-solid fa-down-left-and-up-right-to-center mr-1"></i>
                                                    </span>
                                                    {{ exame.texto }}
                                                </td>
                                                <td width="50%">
                                                    <div v-if="exame.status == 'X'"> <!-- v-if="exame.dic && !exame.dic.filter(it => !it.excluido && !it.fl_blocked).length"> -->
                                                        <button class="btn btn-sm btn-outline-primary mr-1" type="button" @click="iniciar_selecao(exame)">
                                                            <i class="fa fa-plus"></i>
                                                        </button>
                                                        <button class="btn btn-sm btn-outline-danger mr-1" type="button" @click="elimitar_demais(iix)">
                                                            <i class="fa-solid fa-arrows-down-to-line"></i>
                                                        </button>
                                                        <button class="btn btn-sm btn-outline-danger mr-1" type="button" @click="elimitar_demais(iix, false)" v-if="iix">
                                                            <i class="fa-solid fa-arrows-up-to-line"></i>
                                                        </button>
                                                    </div>
                                                    <template v-else>
                                                        <div v-for="(dic, idx) in exame.dic.filter(it => !it.excluido)" :key="idx">
                                                            <az-input
                                                                sizing="sm"
                                                                tst="exame.status == 'P'"
                                                                v-if="dic.procedimento"
                                                                :edicao="false"
                                                                v-model="dic.procedimento.st_procedimento">
                                                                <template v-slot:buttonposb>
                                                                    <div class="input-group-append">
                                                                        <span class="input-group-text small">
                                                                            #{{ dic.procedimento.id_procedimento }}
                                                                        </span>
                                                                        
                                                                        <!-- DropDown -->
                                                                        <button class="btn btn-outline-secondary btn-sm px-1" type="button" id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                                                            <i class="fa-solid fa-ellipsis-vertical"></i>
                                                                        </button>
                                                                        <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
                                                                            <a class="dropdown-item" href="#" @click.prevent="adicionar_proc(exame)">Adicionar Procedimento</a>
                                                                        </div>

                                                                        <button class="btn btn-outline-danger" type="button" title="Remover Termo" @click="remover_item(exame, dic)">
                                                                            <i class="fa fa-times" aria-hidden="true"></i>
                                                                        </button>                                                                       
                                                                    </div>
                                                                </template>
                                                            </az-input>

                                                            <az-input
                                                                :ref="'proc' + iix" 
                                                                sizing="sm"
                                                                v-else-if="exame.status == 'A'"
                                                                placeholder="Procedimento..."
                                                                @focus="tratar_focus(exame, iix)">
                                                                <template v-slot:buttonposb>
                                                                    <div class="input-group-append">
                                                                         <!-- DropDown -->
                                                                        <button class="btn btn-outline-secondary btn-sm px-1" type="button" id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                                                            <i class="fa-solid fa-ellipsis-vertical"></i>
                                                                        </button>
                                                                        <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
                                                                            <a class="dropdown-item" href="#" @click.prevent="unir(exame, iix)">Unir com o próximo texto</a>
                                                                            <a class="dropdown-item" href="#" @click.prevent="desunir(exame, iix)" v-if="exame.partes && exame.partes.length">Separar União</a>
                                                                        </div>

                                                                        <button class="btn btn-outline-danger" type="button" title="Remover Termo" @click="remover_item(exame, dic)">
                                                                            <i class="fa fa-times" aria-hidden="true"></i>
                                                                        </button>
                                                                    </div>
                                                                </template>
                                                            </az-input>

                                                            <az-input
                                                                :ref="'proc' + iix"
                                                                v-else
                                                                placeholder="Procedimento"
                                                                sizing="sm"
                                                                type="autocomplete"
                                                                optionsMode="aql"
                                                                optionsName="procedimentos.combos.agenda"
                                                                :optionsParm="{ id_unidade_operacao: ( dados && dados.marcacao ) ? dados.marcacao.id_unidade_operacao : -1 }"
                                                                optionsName3="( $store.state.user.proc_oper ) ? 'procedimentos.combos.agenda.op.' 
                                                                    + ( novoPlanoCobrancaProcedimento ? 'p.' + novoPlanoCobrancaProcedimento.id_plano : 
                                                                        ( dados.plano.operadora.id_operadora == 1 ? 'p.' + dados.plano.id_plano : dados.plano.operadora.id_operadora ) ) : 'procedimentos.combos.agenda'"
                                                                optionsParm2="( $store.state.user.proc_oper ) 
                                                                    ? ( novoPlanoCobrancaProcedimento 
                                                                        ? { id_operadora: novoPlanoCobrancaProcedimento.id_operadora, id_plano: novoPlanoCobrancaProcedimento.id_plano, id_unidade_operacao: dados.id_unidade_operacao }
                                                                        : { id_operadora: dados.plano.operadora.id_operadora, id_plano: dados.plano.id_plano, id_unidade_operacao: dados.id_unidade_operacao } 
                                                                    )
                                                                    : {
                                                                        id_unidade_operacao: dados.id_unidade_operacao, 
                                                                    }"
                                                                :optionsSync="false"
                                                                v-model="dic.procedimento"
                                                                :procsigla="true"
                                                                @focus="atualizar_canvas (exame.texto, iix)"
                                                                @input="incluirProcedimento (exame, dic, iix)">
                                                                <template v-slot:buttonposb>
                                                                    <div class="input-group-append">

                                                                        <!-- DropDown -->
                                                                        <button class="btn btn-outline-secondary btn-sm px-1" type="button" id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                                                            <i class="fa-solid fa-ellipsis-vertical"></i>
                                                                        </button>
                                                                        <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
                                                                            <a class="dropdown-item" href="#" @click.prevent="unir(exame, iix)">Unir com o próximo texto</a>
                                                                            <a class="dropdown-item" href="#" @click.prevent="desunir(exame, iix)" v-if="exame.partes && exame.partes.length">Separar União</a>
                                                                        </div>

                                                                        <button class="btn btn-outline-danger" type="button" title="Remover Termo" @click="remover_item(exame, dic)">
                                                                            <i class="fa fa-times" aria-hidden="true"></i>
                                                                        </button>
                                                                    </div>
                                                                </template>
                                                            </az-input>

                                                            <pre v-if="false">{{ dic.procedimento }}</pre>

                                                            <az-input
                                                                v-if="1==0"
                                                                placeholder="Selecionar Exame..."
                                                                type="autocomplete"
                                                                service="procedimentos.index"
                                                                optionsMode="aql"
                                                                optionsName="procedimentos.index.ocr.ativos"
                                                                :optionsParm="{ ativos: true }"
                                                                v-model="dic.procedimento"
                                                                ref="info_procedimento">
                                                            </az-input>
                                                        </div>
                                                    </template>
                                                </td>
                                            </tr>
                                        </table>
                                    </div>

                                    <pre v-if="false">{{ dados }}</pre>
                                </div>
                                <div class="col col-12 col-md-6">
                                    <div class="card overflow-auto bg-light card-fixo mb-0" v-if="arquivo">
                                        <div :src="arquivo ? arquivo.temporary_url : ''" style="width: 100%;height: 100%; border: none;" v-if="arquivo && is_image(arquivo)">
                                            <figure class="figure">
                                            
                                                <!-- 
                                                    <viewer :images="[arquivo.temporary_url]">
                                        
                                                <vue-photo-zoom-pro
                                                    v-if="arquivo && arquivo.temporary_url"
                                                    :width="168"
                                                    type="circle" 
                                                    :url="arquivo.temporary_url">
                                                </vue-photo-zoom-pro>
                                                </viewer>
                                                -->
                                                <template>
                                                    <vue-photo-zoom-pro :width="148" type="circle" :scale="2">
                                                        <canvas class="figure-img img-fluid rounded" style="max-height: 100%; max-width: 100%;"  ref="canvasPreview"  id="canvas1"></canvas>
                                                        <template slot="zoomer">
                                                            <canvas class="figure-img img-fluid rounded" style="max-height: 100%; max-width: 100%;"  ref="canvasZoomer" id="canvas2"></canvas>
                                                        </template>
                                                    </vue-photo-zoom-pro>
                                                </template>
                                            </figure>
                                        </div>

                                        <iframe :src="link_office(arquivo)" style="width: 100%;height: 100%; border: none;" v-else-if="arquivo && is_office(arquivo)">
                                            Oops! ocorreu um erro ao abrir o arquivo.
                                        </iframe>

                                        <iframe :src="arquivo ? arquivo.temporary_url : ''" style="width: 100%;height: 100%; border: none;" v-else>
                                            Oops! ocorreu um erro ao abrir o arquivo.
                                        </iframe>
                                    </div>
                                </div>
                            </div>
                        </template>
                    </div>
                    <div class="modal-footer d-flex justify-content-between">
                        <az-input
                            type="checkbox-group"
                            label="Marcar textos com procedimento já selecionado"
                            v-model="flMarcarSelecionados"
                            @input="atualizar_canvas()" />

                        <div>
                            <button type="button" class="btn btn-secondary mr-2" @click="fechar()">Cancelar</button>
                            <az-submit @click="atualizar()">Atualizar</az-submit>
                        </div>    
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import $ from 'jquery';
import _ from 'lodash';
import AzLoading from './AzLoading.vue';
import AzSubmit from './AzSubmit.vue';
import AzInput from '../shared/forms/AzInput.vue';
import VuePhotoZoomPro from 'vue-photo-zoom-pro'
import 'vue-photo-zoom-pro/dist/style/vue-photo-zoom-pro.css'

export default {
    data() {
        return {
            arquivo: null, 
            dados: "", 
            editedImageUrl: "",
            flMarcarSelecionados: false,
            chave_modal: "", 
            sync_lista: true, 
        }
    },

    props: ['modal_id'], 

    components: { 
        AzLoading, 
        AzInput, 
        AzSubmit,
        VuePhotoZoomPro
    },

    computed: { 
        modal_name: function () { 
            return 'ocerizarPedidoModal' + this.modal_id + this.chave_modal; 
        },

        progresso: function () { 
            if ( !this.dados || !this.dados.ocr || !this.dados.ocr.dicionario || !this.dados.ocr.dicionario.length ) { 
                return 0;
            }

            let total = this.dados.ocr.dicionario.filter(exame => exame.status != 'X').length;

            if ( !total ) { 
                return 0;
            }

            return ( this.dados.ocr.dicionario.filter(exame => exame.status == 'P').length / total ) * 100;
        },

        array_posicoes() {

            if(this.dados) {
                const array = _.get(this.dados, 'ocr.js_info.0.detected_texts'); 
                return array ? array : [];
            }

            return [];
        },

        dicionario_para_pesquisa() { 
            if ( !this.dados || !this.dados.ocr || !this.dados.ocr.dicionario ) { 
                return [];
            }

            let dicionario_pesquisa = _.cloneDeep(this.dados.ocr.dicionario);

            return dicionario_pesquisa.map(exame => { 
                
                let palavras = exame.texto.split(' ');

                palavras = palavras.map(palavra => {
                    
                    if(palavra.includes(')')) {
                        palavra = palavra.replaceAll(')', ' )');
                    }
                    
                    if(palavra.includes('(')) {
                        palavra = palavra.replaceAll('(', '( ');
                    }

                    if(palavra.includes('-')) {
                        palavra = palavra.replaceAll('-', ' - ');
                    }

                    return palavra

                });

                exame.texto = palavras.join(' ');

                return exame;
            });
        }
    },

    methods: { 
        tratar_focus(exame, iix) { 
            exame.status = 'E'

            this.$nextTick(() => { 
                let teste = this.$refs['proc' + iix];

                if ( teste && teste.length ) { 
                    teste[0].$refs.input.focus();
                }
            });
        },

        adicionar_proc (exame) { 
            exame.dic.push({ 
                id_procedimento: null, 
                id_dicionario_pedido: null, 
                procedimento: "", 
                excluido: false, 
                fl_blocked: false, 
            });
        },

        desunir (exame, idx) { 
            if ( !exame.partes ) { 
                return;
            }

            exame.texto = exame.partes[0];

            let partes = exame.partes.slice(1);

            partes.forEach(parte => { 
                this.dados.ocr.dicionario.splice(
                    idx + 1, 
                    0, 
                    { 
                        texto: parte, 
                        dic: [
                            { 
                                id_procedimento: null, 
                                id_dicionario_pedido: null, 
                                procedimento: "", 
                                excluido: false, 
                                fl_blocked: false, 
                            }
                        ], 
                        status: 'A',
                    }
                );
            });

            exame.partes = null;
        },
        unir (exame, idx) { 
            if ( idx == this.dados.ocr.dicionario.length - 1 ) { 
                return;
            }

            if ( !exame.partes ) { 
                exame.partes = [exame.texto];
            }

            exame.texto = exame.texto + ' ' + this.dados.ocr.dicionario[idx + 1].texto;
            exame.partes.push(this.dados.ocr.dicionario[idx + 1].texto);
            
            this.dados.ocr.dicionario.splice([idx + 1], 1);
        },

        atualizar () { 
            this.$util.atualizar(this, { 
                service: 'arquivos',
                func: 'salvar_dicionario_pedido',
                dados: this.dados.ocr,
                modal: this.modal_name, 
                toast: true, 
                callback: res => { 
                    this.$emit('refresh', res);
                }
            });
        },

        elimitar_demais (index, down = true) { 
            this.dados.ocr.dicionario.forEach( (exame, iix) => { 
                if ( ( iix >= index && down ) || ( iix <= index && !down ) ) { 
                    let teste = exame.dic.find(it => it.procedimento);

                    if ( teste ) { 
                        return;
                    }

                    exame.status = 'X';

                    teste = exame.dic.find(it => !it.procedimento && !it.excluido && !it.fl_blocked);

                    if ( teste ) { 
                        teste.fl_blocked = true;
                    }
                }
            });
        },

        iniciar_selecao (exame) { 
            if ( exame.status == 'X' ) { 
                exame.status = 'A';
            }

            exame.dic.filter(it => !it.excluido && it.fl_blocked)
                .forEach(it => { 
                    it.excluido = true 
                });

            exame.dic.push({ 
                id_procedimento: null, 
                id_dicionario_pedido: null, 
                procedimento: "", 
                excluido: false, 
                fl_blocked: false, 
            });
        },
        remover_item(exame, dic) { 
            if ( exame.dic.length == 1 ) { 
                if ( exame.dic[0].procedimento ) { 
                    exame.dic[0].procedimento = "";
                    this.atualizar_canvas()
                    return;
                }
            }

            dic.excluido = true; 

            if ( !exame.dic.find(it => !it.excluido) ) { 
                exame.status = 'X';
            }

            console.log('exame', exame);
            console.log('dic', dic);

        },
        incluirProcedimento (exame, dic, idx) { 
            if ( dic && dic.procedimento && Array.isArray(dic.procedimento) ) { 

                exame.dic = dic.procedimento.map( p => { 
                    return { 
                        id_procedimento: null, 
                        id_dicionario_pedido: null, 
                        procedimento: p, 
                        excluido: false, 
                        fl_blocked: false,
                    };
                });

                if ( exame[idx + 1] && exame[idx + 1].status == 'A' ) { 
                    this.tratar_focus(exame, idx + 1);
                    return;
                }
            
                let teste = this.$refs['proc' + ( idx + 1 )];

                if ( teste && teste.length ) { 
                    teste[0].$refs.input.focus();
                }

            }
        },

        fechar () { 
            $('#' + this.modal_name).modal('hide');
        },

        ocerizar_pedido(arquivo, id_marcacao = null) {
            this.dados = "";
            this.conteudo_arquivo = null; 
            this.arquivo = _.cloneDeep(arquivo);

            $('#' + this.modal_name).modal('show');

            this.$util.atualizar(this, { 
                service: 'arquivos',
                func: 'ocerizar_pedido',
                redir_api: true,
                dados: {
                    id_arquivo: this.arquivo.id_arquivo, 
                    id_marcacao: id_marcacao,
                },
                callback: res => { 
                    this.dados = res;

                    this.$nextTick(() => {
                        this.atualizar_canvas();
                        this.sync_lista = false;
                    });
                }
            });
        },

        is_image (arquivo) { 
            return arquivo.st_tipo_arquivo == 'png' || arquivo.st_tipo_arquivo == 'jpg' || arquivo.st_tipo_arquivo == 'jpeg';
        },

        is_office (arquivo) { 
            return arquivo.st_tipo_arquivo == 'docx' || arquivo.st_tipo_arquivo == 'xlsx' || arquivo.st_tipo_arquivo == 'pptx';
        },

        link_office(arquivo) { 
            return "https://view.officeapps.live.com/op/view.aspx?src=" 
                + encodeURIComponent(arquivo.temporary_url)
                + '&wdEmbedCode=0&wdPrint=0';
        },

        atualizar_canvas (texto = null, index = null) {

            /*Função que marca as palavras. 
            Cria um canvas, marca a palavra baseado na sua posição */

            if( !this.arquivo || !this.is_image(this.arquivo) ) 
                return;
            
            const canvasPreview = this.$refs.canvasPreview;
            const ctxPreview = canvasPreview.getContext('2d');
            const canvasZoomer = this.$refs.canvasZoomer;
            const ctxZoomer = canvasZoomer.getContext('2d');
        
            const imagem = new Image();
            imagem.src = this.arquivo.temporary_url;
            
            imagem.onload = () => {
                this.desenhar_imagem(canvasPreview, ctxPreview, imagem, texto, index);
                canvasZoomer.width = canvasPreview.width;
                canvasZoomer.height = canvasPreview.height;
                ctxZoomer.drawImage(canvasPreview, 0, 0);
            }
            
        },

        desenhar_imagem (canvas, ctx, imagem, texto = null, index = null) {

            canvas.width = imagem.width;
            canvas.height = imagem.height;
            ctx.drawImage(imagem, 0, 0, canvas.width, canvas.height);

            const dicionario = this.dicionario_para_pesquisa;
            //Logica para marcar textos selecionados
            if(this.flMarcarSelecionados) {

                const dicionarioComIndex = dicionario.map((item, index) => {
                    return { ...item, index };
                });

                const arraySelecionados = dicionarioComIndex.filter(item => {
                    return item.dic && item.dic.some(item2 => item2.procedimento);
                });

                arraySelecionados.forEach((item) => {

                    const arrayTextosSelecionados = item.texto.split(' ');

                    arrayTextosSelecionados.forEach(word => {
                        
                        const arrayFiltradoSelecionados = this.array_posicoes.filter(item => {
                            return item.description.toUpperCase() == word;
                        });

                        if(arrayFiltradoSelecionados.length > 0) {
                        
                            const arrayIndicesSelecionados = this.dicionario_para_pesquisa.map((item, index2) => {
                            
                                const arrayTextosSelecionados = item.texto.split(' ');
                                
                                if(arrayTextosSelecionados.includes(word)) {
                                    return index2;
                                }

                            });

                            const indicesDefinidosSelecionados = arrayIndicesSelecionados.filter(item => item != undefined);
                            
                            const indicesRealSelecionados = indicesDefinidosSelecionados.indexOf(item.index);

                            if(indicesRealSelecionados != -1 && indicesRealSelecionados < arrayFiltradoSelecionados.length) {

                                const registroSelecionados = arrayFiltradoSelecionados[indicesRealSelecionados];

                                const posicoesSelecionados = registroSelecionados.position;

                                const x1Selecionados = posicoesSelecionados[0].x;
                                const x2Selecionados = posicoesSelecionados[1].x;
                                const y1Selecionados = posicoesSelecionados[0].y; 
                                const y2Selecionados = posicoesSelecionados[2].y;

                                ctx.fillStyle = 'rgba(0, 255, 0, 0.3)';
                                ctx.fillRect(x1Selecionados, y1Selecionados-1, x2Selecionados - x1Selecionados, y2Selecionados - (y1Selecionados-2));

                            }
                        }

                    });

                });
            }

            if(texto) {

                const splittedText = this.dicionario_para_pesquisa[index].texto.split(' ');
                
                splittedText.forEach(word => {

                        /*
                        variavel index: índice da palavra no dicionario
                        variavel word: palavra a ser destacada
                        array_posicoes: computed property que retorna js_info 
                        */

                        //pego todas as aparições da palavra no array js_info
                        const arrayFiltrado = this.array_posicoes.filter(item => {
                            return item.description.toUpperCase() == word;
                        });

                        if(arrayFiltrado.length > 0) {

                            //Pego o índice de todas as aparições da palavra no dicionário
                            const arrayIndices = this.dicionario_para_pesquisa.map((item, index2) => {
                            
                                const arrayTextos = item.texto.split(' ');
                                
                                if(arrayTextos.includes(word)) {
                                    return index2;
                                }

                            });

                            //removo os índices indefinidos (sem aparição da palavra no dicionário)
                            const indicesDefinidos = arrayIndices.filter(item => item != undefined);

                            //pego a posição da palavra no dicíonário (se é a primeira ou a segunda aparição, por exemplo)
                            const indiceReal = indicesDefinidos.indexOf(index);

                            if(indiceReal != -1 && indiceReal < arrayFiltrado.length) {

                                //Pego a palavra no js_info
                                const registro = arrayFiltrado[indiceReal];

                                const posicoes = registro.position;

                                const x1 = posicoes[0].x;
                                const x2 = posicoes[1].x;
                                const y1 = posicoes[0].y; 
                                const y2 = posicoes[2].y;

                                ctx.fillStyle = 'rgba(255, 255, 0, 0.3)';
                                ctx.fillRect(x1, y1-1, x2 - x1, y2 - (y1-2));

                            }
                        }

                });

            }

            //this.editedImageUrl = canvas.toDataURL();
            //canvas.remove();
        }
    },

    beforeMount() {
        this.chave_modal = this.$util.uuidv4();
    },
}
</script>

<style scoped>
.modal-dialog-total {
  top: 0;
  width: 100% !important;
  height: 100% !important;
  padding: 0 !important;
  max-width: 100% !important;
  max-height: 100% !important;
  margin-top: 0px;
  margin-bottom: 0px;
  margin: 0px !important;
}

.modal-content-total {
  height: 100% !important;
  max-height: 100% !important;
}

.card-fixo { 
  padding: 0px; 
  height: calc(100vh - 100px);
}
</style>